<template>
  <div>
    <v-card class="mt-6">
      <v-layout class="py-5 px-6">
        <h3 class="pr-4">Guarantees</h3>
        <v-spacer></v-spacer>
        <order-guarantees v-if="items.length > 1" :items="items" @done="initialize">
          <template v-slot:default="{ click }">
            <v-btn color="primary" class="mr-2" @click="click">
              <v-icon left>low_priority</v-icon>
              Change Order
            </v-btn>
          </template>
        </order-guarantees>
        <add-guarantee @done="initialize">
          <template v-slot:default="{ click }">
            <v-btn color="success" @click="click">
              <v-icon left>add</v-icon>
              Add New
            </v-btn>
          </template>
        </add-guarantee>
      </v-layout>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        loader-height="2"
        hide-default-footer
        disable-pagination
        class="client-credit-cards my-sticky-last-column-table"
        mobile-breakpoint="100"
      >
        <template v-slot:item="{item}">
          <tr class="items-body-row">
            <td>
              <span v-if="!no_data.includes(item.name)">{{ item.name }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.description)">{{ item.description }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <template v-if="!no_data.includes(item.approved)">
                <v-chip
                  v-if="Boolean(Number(item.approved))"
                  color="success"
                  small
                >
                  Yes
                </v-chip>
                <v-chip
                  v-else
                  color="orange darken-4"
                  text-color="white"
                  small
                >
                  No
                </v-chip>
              </template>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <v-flex style="min-width: 65px;">
                <edit-guarantee @done="initialize">
                  <template v-slot:default="{ click }">
                    <v-flex
                      class="pr-2 action-link"
                      @click="click(item)"
                      >Edit <v-icon>edit</v-icon>
                    </v-flex>
                  </template>
                </edit-guarantee>
                <delete-guarantee @done="initialize">
                  <template v-slot:default="{ click }">
                    <v-flex
                      class="pr-2 action-link error--text"
                      @click="click(item)"
                      >Delete <v-icon color="error">delete</v-icon>
                    </v-flex>
                  </template>
                </delete-guarantee>
              </v-flex>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import AddGuarantee from "./AddGuarantee"
import DeleteGuarantee from "./DeleteGuarantee"
import EditGuarantee from "./EditGuarantee"
import OrderGuarantees from "./OrderGuarantees"

export default {
  name: 'Guarantees',
  components: {
    AddGuarantee,
    EditGuarantee,
    DeleteGuarantee,
    OrderGuarantees
  },
  data() {
    return {
      no_data: [null, '', undefined, 'null'],
      loading: false,
      items: [],
      headers: [
        {
          text: "Guarantee Name",
          value: "name",
          sortable: false
        },
        {
          text: "Description",
          value: "description",
          sortable: false,
        },
        {
          text: "Approved",
          value: "approved",
          sortable: false,
        },
        {
          text: "Actions",
          sortable: false,
          width: "170px",
          align: "left"
        }
      ],
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.loading = true
      ApiService.get('/gotpooperscoopers/guarantee')
        .then(response => {
          this.items = response.data.guarantees
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    }
  }
}
</script>